import styled from "@emotion/styled";

const TooltipWrapper = styled.p`
  display: inline-block;
  position: relative;
  cursor: pointer;
`;

const TooltipText = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  max-width: 100%;
  cursor: pointer;
  height: 20px;
  @media (max-width: 768px) {
    margin-bottom: 2px;
  }
`;

const Text = styled.span`
  display: block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;

  font-size: ${({ isMobile }) => (isMobile ? "13px" : "14px")};
  // line-height: 1.3;

  /* Touch-friendly spacing */
  // padding: ${({ isMobile }) => (isMobile ? "2px 0" : "0")};
`;

const SC = {
  TooltipWrapper,
  TooltipText,
  Text,
};

export default SC;
